import { render, staticRenderFns } from "./StatsCARatiosCouts.vue?vue&type=template&id=87a5cbea"
import script from "./StatsCARatiosCouts.vue?vue&type=script&lang=js"
export * from "./StatsCARatiosCouts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports